import {initializeApp} from 'firebase/app';
import {getAnalytics, logEvent} from 'firebase/analytics';
import {getPerformance} from 'firebase/performance';
import {getAuth, connectAuthEmulator, signInAnonymously} from 'firebase/auth';
export type {User} from 'firebase/auth';
import {prodConfig, stagingConfig} from './firebaseConfig';
import {debug, isProd} from './common';

debug('Executing firebase.ts');

export const firebaseConfig = isProd ? prodConfig : stagingConfig;
export const firebaseApp = initializeApp(firebaseConfig);

// DISABLED; CAUSES HUGE DOWNLOAD.
// Create a ReCaptchaEnterpriseProvider instance using your reCAPTCHA Enterprise
// site key and pass it to initializeAppCheck().
export const useEmulators = window.location.hostname === 'localhost';
export const enableRecaptcha = !useEmulators && false; // DISABLED

export const auth = getAuth(firebaseApp);
if (useEmulators) {
  console.log('USING EMULATORS');
  connectAuthEmulator(auth, 'http://localhost:9099');
}

export const analytics = getAnalytics();

export const perf = getPerformance(firebaseApp);

export const waitForCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      unsubscribe();
      resolve(user);
    }, reject);
  });
};

export const signInAnonymouslyIfNecessary = async () => {
  debug('signInAnonymouslyIfNecessary');
  if (await waitForCurrentUser()) return;

  try {
    await signInAnonymously(auth);
    logEvent(analytics, 'anonymousSignin');
  } catch (e: any) {
    logEvent(analytics, 'anonymousSigninError', {code: e.code});
    console.error(e);
  }
};
